module.exports = __webpack_public_path__ + "assets/img/smsimg4.6ee796da.png";